export const NavigationLinkTypesEnum = {
  HtmlId: {
    key: 0,
    value: "section",
  },
  Hyperlink: {
    key: 1,
    value: "external-link",
  },
  InternalPage: {
    key: 2,
    value: "internal-page",
  },
};
